import type { SVGProps } from 'react';
const actionCrossTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.9869 12.1578L4.49764 18.4567L4.43839 18.5213C4.20092 18.8122 4.21396 19.2413 4.48186 19.5173C4.77036 19.8145 5.24518 19.8216 5.5424 19.5331L12.0637 13.2031L18.5849 19.5331C18.8821 19.8216 19.357 19.8145 19.6455 19.5173C19.9133 19.2413 19.9264 18.8122 19.6889 18.5213L19.6297 18.4567L13.1405 12.1578L19.6297 5.85896L19.6889 5.79442C19.9264 5.50354 19.9133 5.07441 19.6455 4.79842C19.3569 4.5012 18.8821 4.49414 18.5849 4.78264L12.0637 11.1126L5.5424 4.78264C5.24518 4.49414 4.77036 4.5012 4.48186 4.79842C4.21396 5.07441 4.20092 5.50354 4.43839 5.79442L4.49764 5.85896L10.9869 12.1578Z"
      fill={props.color ?? '#000'}
    />
  </svg>
);
export default actionCrossTemplateOutline;
